var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Aba ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Aba*",
      "counter": "40",
      "outlined": "",
      "dense": "",
      "maxlength": "40",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome de Exibição*",
      "counter": "40",
      "maxlength": "40",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.nomeDeExibicao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nomeDeExibicao", $$v);
      },
      expression: "content.nomeDeExibicao"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.form.lists.listPermissoes,
      "item-text": 'nomeDeExibicao',
      "item-value": 'id',
      "rules": [function (p) {
        return p.some(function (v) {
          return _vm.$required(v);
        }) || 'Campo obrigatório';
      }],
      "label": "Permissões*",
      "multiple": "",
      "outlined": "",
      "dense": "",
      "return-object": ""
    },
    model: {
      value: _vm.content.permissoes,
      callback: function ($$v) {
        _vm.$set(_vm.content, "permissoes", $$v);
      },
      expression: "content.permissoes"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": _vm.edit ? 'Salvar' : 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }